import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

// Render the canvas at a high fixed resolution so the downloaded PNG is crisp,
// then scale it down to `size` for display via CSS.
const EXPORT_SIZE = 1024;

const QrCodeView = forwardRef(({ value, size }, ref) => {
  const canvasRef = useRef(null);

  useImperativeHandle(ref, () => ({
    toDataURL: (callback) => {
      const dataUrl = canvasRef.current?.toDataURL('image/png') || '';
      callback(dataUrl.replace('data:image/png;base64,', ''));
    },
  }));

  return (
    <QRCodeCanvas
      value={value}
      size={EXPORT_SIZE}
      marginSize={4}
      bgColor="#FFFFFF"
      fgColor="#000000"
      level="M"
      style={{ width: size, height: size }}
      ref={canvasRef}
    />
  );
});

export default QrCodeView;
